"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = exports.reducer = exports.initialState = exports.Action = void 0;
var product_validation_state_1 = require("./product-validation-state");
Object.defineProperty(exports, "Action", { enumerable: true, get: function () { return product_validation_state_1.Action; } });
Object.defineProperty(exports, "initialState", { enumerable: true, get: function () { return product_validation_state_1.initialState; } });
Object.defineProperty(exports, "reducer", { enumerable: true, get: function () { return product_validation_state_1.reducer; } });
var product_validation_view_1 = require("./product-validation-view");
Object.defineProperty(exports, "View", { enumerable: true, get: function () { return product_validation_view_1.View; } });
//# sourceMappingURL=index.js.map